<template>
    <div class="a-modal">
        <div class="popup__header popup__header--border">
            <span class="title title--sm popup__title">{{ $lang('addPage.title') }}</span>

            <span class="create__step">{{ $lang('addPage.step') }} {{ step }}/2</span>
        </div>

        <div class="popup__content">
            <h3 class="title title--s a-modal__body-title" v-if="!disabled" v-html="title"/>
            <!--<span class="a-modal__description">Если данных пока нет, оставляйте поля не заполненными</span>-->
            <form class="a-modal__add-form form">
                <div class="a-modal__top" id="top" v-if="!disabled">
                    <div class="a-filters__top-item a-filters__top-item--grow" v-if="isAdmin">
                        <span class="a-filters__name">{{ $lang('addPage.select.partner') }}</span>

                        <search-partner
                            class="a-filters__el--autocomplete select--absolute"
                            v-model="partnerCode"
                            :disabled="isMaster">
                        </search-partner>
                    </div>

                    <div class="a-filters__top-item a-filters__top-item--grow" v-if="isAdmin || isPartner">

                    <span class="a-filters__name">{{ $lang('addPage.select.master') }}</span>
                        <el-popover v-model="errors.master.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="150"
                                    popper-class="add__error-popover"
                                    :content="$lang('addPage.select.master.content')">
                                <search-master
                                    class="a-filters__el--autocomplete select--absolute"
                                    :class="{ 'add__error': errors.master.isError }"
                                    v-model="masterCode"
                                    @focus="clearErrors()"
                                    :search-params="mastersSearchParams"
                                    slot="reference">
                                </search-master>
                        </el-popover>
                    </div>

                    <div class="a-filters__top-item a-filters__top-item--grow" v-if="isAdmin || isPartner || isMaster">
                        <span class="a-filters__name" v-if="!isMaster">{{ $lang('addPage.select.user') }}</span>

                        <el-popover v-model="errors.responsible.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="100%"
                                    popper-class="add__error-popover"
                                    :content="$lang('addPage.select.user.content')">
                            <search-resposible
                                class="a-filters__el--autocomplete select--absolute"
                                :class="{ 'add__error': errors.responsible.isError }"
                                v-model="responsibleCode"
                                @focus="clearErrors()"
                                :search-params="responsiblesSearchParams"
                                :exclude-from-full-search="['masterUserId', 'partnerUserId']"
                                :show-email-and-phone="isMaster"
                                slot="reference"
                                dusk="responsible">
                            </search-resposible>
                        </el-popover>
                    </div>
                </div>
                <h3 class="title title--s a-modal__body-subtitle">{{ $lang('addPage.type.title') }}</h3>

                <button :dusk="item.dusk" v-for="(item, index) in pagesTypes" v-if="pagesTypes" type="button" class="btn a-modal__type" :class="type === item.type ? 'a-modal__type--active' : ''" @click.prevent="type = item.type">
                    <img :src="'/assets/front/img/add_page/' + item.img" alt="#" class="a-modal__type-img">

                    <span class="a-modal__type-box">
                        <span class="a-modal__type-name"><span>{{ parseInt(index) + 1 }}. </span>{{ item.name }}</span>

                        <span v-if="parseInt(item.price)" class="a-modal__type-value">{{ item.price | priceFormat }} {{ prices.currency.symbol }}</span>
                    </span>
                </button>
            </form>
        </div>

        <div class="popup__footer">
            <button dusk="further" class="btn btn--middle btn--main-bg" @click.prevent="adminCreatePage">{{ $lang('addPage.button1') }}</button>
        </div>
    </div>
</template>

<script>
    import ApiService from '../../../api/api';
    import SearchPartner from "../../../components/searchSelect/SearchPartner";
    import SearchMaster from "../../../components/searchSelect/SearchMaster";
    import SearchResposible from "../../../components/searchSelect/SearchResposible";
    import Vue from "vue";

    export default {
        name: "AddPage",
        components: {SearchPartner, SearchMaster, SearchResposible},
        data: () => ({
            isAdmin: window.laravel.isAdmin,
            isPartner: window.laravel.isPartner,
            isMaster: window.laravel.isMaster,
            isResponsible: window.laravel.isResponsible,
            pagesTypes: [],
            step: 1,
            responsibleCode: '',
            masterCode: '',
            partnerCode: '',
            type: 2,
            prices: window.laravel.prices,
            locale: window.laravel.locale,
            errors: {
                responsible: {isError: false},
                master: {isError: false},
            },
            titleFor: {
                master: Vue.prototype.$lang('addPage.select.title.forMaster'),
                any: Vue.prototype.$lang('addPage.select.title'),
            }
        }),
        watch: {
            partnerCode: {
                handler: function (val) {
                    if (!val) {
                        return false;
                    }

                    if (!this.isMaster) {
                        this.masterCode = undefined;
                        this.responsibleCode = undefined;
                    }
                },
                deep: true
            },
            masterCode: {
                handler: function (val) {
                    if (!val) {
                        return false;
                    }

                    this.responsibleCode = this.$route.params.user_id ?? undefined;
                },
                deep: true
            },
        },
        computed: {
            responsiblesSearchParams() {
                if (this.isMaster) {
                    return { masterUserId: this.masterCode };
                }

                return {
                    masterUserId: this.masterCode,
                    partnerUserId: this.partnerCode
                }
            },
            mastersSearchParams() {
                return {
                    partner_id: this.partnerCode
                }
            },
            disabled() {
                if (this.isResponsible) {
                    return true;
                }

                return (this.isMaster && this.$route.params.user_id) ? true : false;
            },
            pageSlug() {
                let urlParams = new URLSearchParams(window.location.search);

                return urlParams.get('slug');
            },
            queryParams() {
                let params = {};

                if (this.pageSlug) {
                    params.slug = this.pageSlug;
                }

                if (this.isPartnerBlank) {
                    params.isPartnerBlank = true;
                }

                return params;
            },
            isPartnerBlank() {
                return this.$route.query.isPartnerBlank ?? false;
            },
            title() {
                return this.isMaster
                    ? this.titleFor.master
                    : this.titleFor.any
            }
        },
        methods: {
            adminCreatePage() {
                if (this.validate()) {
                    if (this.type === 1) {
                        let location = {
                            name: 'cabinet-create-free',
                            params: {
                                master: this.masterCode,
                                responsible: this.responsibleCode,
                                partner: this.partnerCode,
                                notRedirect: this.$route.params.notRedirect ?? false
                            },
                            query: this.queryParams
                        };

                        // Если ответственный отсканировал партнерскую табличку
                        if (this.isResponsible && this.isPartnerBlank) {
                            location.name = 'cabinet-create-pay';
                            location.params.price = this.prices.table.price;
                            location.params.paymentType = 4;
                        }

                        this.$router.push(location);
                    } else if (this.type === 2) {
                        this.$router.push({
                            name: 'cabinet-create-pay',
                            params: {
                                price: this.prices.full.price,
                                paymentType: 1,
                                master: this.masterCode,
                                responsible: this.responsibleCode,
                                partner: this.partnerCode,
                                notRedirect: this.$route.params.notRedirect ?? false
                            },
                            query: this.queryParams
                        });
                    } else if (this.type === 4) {
                        this.$router.push({
                            name: 'cabinet-create-pay',
                            params: {
                                price: this.prices.fullWithCopyright.price,
                                paymentType: 1,
                                master: this.masterCode,
                                responsible: this.responsibleCode,
                                partner: this.partnerCode,
                                notRedirect: this.$route.params.notRedirect ?? false,
                                copyright: true,
                            },
                            query: this.queryParams
                        });
                    } else if (this.type === 3) {
                        this.$router.push({
                            name: 'cabinet-create-pay',
                            params: {
                                price: this.prices.burial.price,
                                paymentType: 3,
                                master: this.masterCode,
                                responsible: this.responsibleCode,
                                partner: this.partnerCode,
                                burial: true,
                                burial_id: this.$route.params.burial_id ?? 0,
                                notRedirect: this.$route.params.notRedirect ?? false
                            },
                            query: this.queryParams
                        });
                    } else if (this.type === 5) {
                        this.$router.push({
                            name: 'cabinet-create-pay',
                            params: {
                                price: this.prices.burialWithCopyright.price,
                                paymentType: 3,
                                master: this.masterCode,
                                responsible: this.responsibleCode,
                                partner: this.partnerCode,
                                burial: true,
                                burial_id: this.$route.params.burial_id ?? 0,
                                notRedirect: this.$route.params.notRedirect ?? false,
                                copyright: true,
                            },
                            query: this.queryParams
                        });
                    }
                }
            },
            validate() {
                let flag = true;

                if (!this.responsibleCode) {
                    this.errors['responsible']['isError'] = true;
                    flag = false;
                    document.getElementById("top").scrollIntoView({block: "center", behavior: "smooth"});
                }

                if (this.isPartner && !this.masterCode) {
                    this.errors['master']['isError'] = true;
                    flag = false;
                    document.getElementById("top").scrollIntoView({block: "center", behavior: "smooth"});
                }

                if (this.partnerCode && !this.masterCode && !this.isPartnerBlank) {
                    this.errors['master']['isError'] = true;
                    flag = false;
                    document.getElementById("top").scrollIntoView({block: "center", behavior: "smooth"});
                }

                return flag;
            },
            clearErrors() {
                this.errors['responsible']['isError'] = false;
                this.errors['master']['isError'] = false;
            },
            getDefaultPartner() {
                ApiService.get('/default-partner')
                    .then((response) => {
                        this.partnerCode = response.data;
                        console.log('partner code was set');
                    }).catch((error) => {
                    console.log(error);
                });
            },
            adminMode() {
                // this.getPartnersList();
            },
            masterMode() {
                this.getDefaultPartner();

                this.masterCode = window.laravel.user.id;
            },
            modeResponsible() {
                this.responsibleCode = window.laravel.user.id;
            }
        },
        mounted() {
            if ((this.pageSlug && parseInt(this.prices.table.price)) || !this.pageSlug) {
                this.pagesTypes.push({
                    dusk: 'short-page',
                    type: 1,
                    img: '1.svg',
                    name: this.pageSlug ? this.$lang('addPage.type.shortWithTable') : this.$lang('addPage.type.short'),
                    price: this.pageSlug ? this.prices.table.price : 0
                });
            }

            if (parseInt(this.prices.full.price)) {
                this.pagesTypes.push({
                    dusk: 'full-page',
                    type: 2,
                    img: '2.svg',
                    name: this.$lang('addPage.type.full'),
                    price: this.prices.full.price
                });
            }

            if (parseInt(this.prices.fullWithCopyright.price)) {
                this.pagesTypes.push({
                    dusk: 'full-with-copyright-page',
                    type: 4,
                    img: '2.svg',
                    name: this.$lang('addPage.type.fullWithCopyright'),
                    price: this.prices.fullWithCopyright.price
                });
            }

            if (parseInt(this.prices.burial.price)) {
                this.pagesTypes.push({
                    dusk: 'burial-page',
                    type: 3,
                    img: '3.svg',
                    name: this.$lang('addPage.type.burial'),
                    price: this.prices.burial.price
                });
            }

            if (parseInt(this.prices.burialWithCopyright.price)) {
                this.pagesTypes.push({
                    dusk: 'burial-with-copyright-page',
                    type: 5,
                    img: '4.svg',
                    name: this.$lang('addPage.type.burialWithCopyright'),
                    price: this.prices.burialWithCopyright.price
                });
            }
        },
        created() {
            if (this.isAdmin) {
                this.adminMode();
            }

            if (this.isMaster) {
                this.masterMode();
            }

            if (this.isResponsible) {
                this.modeResponsible();
            }

            if (this.$route.params.type) {
                this.type = this.$route.params.type;
            }
        }
    }
</script>

<style>
    .hidden_select {
        display: none;
    }
</style>
